import { styled } from 'styled-components';
import { themeModules } from "../../theme/theme.js"
import Navbar  from'../navbar.jsx';
import NavigationClient from "./navigationClient.jsx"
import { Outlet } from 'react-router-dom'


let Container=styled.div`
	background-color:${themeModules.background};
	height:100vh
`;

export default function ClientDashboard(){
	
	return(
	<Container>
		<Navbar navigation={<NavigationClient/>}/>
		<Outlet/>
	</Container>)
}